const booking = {
  bookingInformation: "Informações de reserva", // translated
  ourCancellationPolicy: "Nossa Política de Cancelamento", // translated
  thisAupersedesAnyCancellationPolicyInRemarksAbove: "Isso substitui qualquer política de cancelamento nas observações acima", // translated
  thisBookingIsNonNefundable: "Esta reserva não é reembolsável", // translated
  paymentTerms: "Termos de pagamento", // translated
  paymentWillBeTakenFromYourDefault: "O pagamento será retirado do seu padrão", // translated
  paymentMethod: "Forma de pagamento", // translated
  afterTheFreeCancellationPeriodIfApplicable: "após o período de cancelamento gratuito, se aplicável", // translated
  prebook: "Pré-livro", // translated
  guests: "Convidados", // translated
  payment: "Pagamento", // translated
  byClicking: "Clicando", // translated
  youAreAgreeingToOur: "você está concordando com o nosso", // translated
  termsAndConditions: "Termos e Condições", // translated
  lastBookableDate: "Data da última reserva", // translated
  customerRemarksTextfield: "Observações do cliente", // translated
  request: "Solicitação", // translated
};

export default booking;
